import type React from "react";

import ErrorBoundary from "metabase/ErrorBoundary";
import { color } from "metabase/lib/colors";
import { Box, Icon } from "metabase/ui";

import { NotFound } from "../ErrorPages";

import S from "./AdminPeopleLayout.module.css";

export const AdminPeopleLayout = ({
  sidebar,
  children,
  maw = "50rem",
}: {
  sidebar?: React.ReactNode;
  children?: React.ReactNode;
  maw?: string;
}) => {
  return (
    <Box style={{
          display: "flex",
          justifyContent: "center",
          width: "92vw",
          margin: "2rem auto",
          overflow: "hidden",
          backgroundColor: "transparent",
    }}>
      <Box>
        {sidebar && (
          <Box style={{
            display: "flex",
            gap: "2rem",
            position: "relative",
            justifyContent: "center",
            width: "100%",
            overflow: "hidden",
            marginLeft: "2rem",
          }}  data-testid="admin-layout-sidebar">
            <div className={S.HeaderLeft} style={{ backgroundColor: color("admin-navbar"), width: "4rem", height: "4rem", borderRadius: "50%", cursor: "pointer", alignItems: "center", justifyContent: "center", display: "flex" }}>
              <Box className={S.BackButton} onClick={() => history.back()}>
                <Icon name="arrow_left" size={20} color="white" />
              </Box>
            </div>
            {sidebar}
          </Box>
        )}
        <Box className={S.Content} style={{
          display: "flex",
          justifyContent: "center",
          background: "transparent",
          border: "none",
          width: "95vw",
          margin: "1rem",
          overflow: "hidden",
        }} data-testid="admin-layout-content">
          <Box maw={maw} w="100%">
            <Box pb="2rem">
              <ErrorBoundary>{children ?? <NotFound />}</ErrorBoundary>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
